// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9777) return "static/chunks/recorder.4d74e3253d2538b8.js";
	if (chunkId === 12) return "static/chunks/profiler.cde8eb583d3276a2.js";
	if (chunkId === 7816) return "static/chunks/7816.375d6f1b37598997.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1447":"563d08392b49099d","1700":"06326e5ab961e5ca","7106":"335846b307861816","9759":"a80d97e5dbca5460","9944":"167eb5a3b288f3b8"}[chunkId] + ".js";
};